import FilterDefinition from 'helpers/search_filters/filter_definition';
import EnumFormatter from '../../search_filters/formatters/enum_formatter';
import { propertyTypeMappings } from '../../property_types';

import AddressFilterDefinitions from './address_filters';
import IndustrialFilterDefinitions from './industrial_filters';
import PropertyFilterDefinitions from './property_filters';
import LeaseFilterDefinitions from './lease_filters';
import SaleFilterDefinitions from './sale_filters';
export const assetClasses = new FilterDefinition({
  label: 'Property Type',
  value: query => query.assetClasses,
  formatter: new EnumFormatter(propertyTypeMappings),
});

export const buildingClasses = new FilterDefinition({
  label: 'Building Class',
  value: query => query.buildingClasses
});

export const searchText = new FilterDefinition({
  label: 'Contains text',
  value: query => query.searchText
});

const filters = [
  searchText,
  assetClasses,
  buildingClasses,
  ...AddressFilterDefinitions,
  ...PropertyFilterDefinitions,
  ...IndustrialFilterDefinitions,
  ...SaleFilterDefinitions,
  ...LeaseFilterDefinitions
];

export default filters;
